import { Button } from '../Button'
import { ButtonProps } from '../Button/Types'
import { ReactComponent as DeleteIcon } from './delete16.svg'
import Styles from './DeleteButton.module.scss'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

interface Props extends Pick<ButtonProps, 'onPress' | 'isDisabled'> {}

export const DeleteButton = ({ onPress, isDisabled }: Props) => (
  <Button
    isDisabled={isDisabled}
    onPress={onPress}
    frontIcon={DeleteIcon}
    className={ItemStyles.controlItem}
    iconClassName={Styles.deleteIcon}
    variant="tertiary"
    size="sm"
  >
    Delete
  </Button>
)
